import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, Button, Combobox, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Field, Input, Option } from "@fluentui/react-components";
import { User, UserUpdateDTO } from "../../models/users";
import { useState, useEffect } from "react";
import apiClient from "../../services/api";
import { updateUser } from "../../services/usersService";
import { useAppContext } from "../../AppContext";
import { DismissRegular } from "@fluentui/react-icons";

type Props = {
  onClose: () => void;
  open: boolean;
  user: User;
  onUserUpdated: (updatedUser: User) => void;
};

const EditUserDialog = (props: Props) => {
  const [formData, setFormData] = useState<UserUpdateDTO>({
    Email: "",
    FirstName: "",
    LastName: "",
    Title: "",
    PhoneNumber: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const {featurePermissions} = useAppContext();

  useEffect(() => {
    if (props.user && props.open) {
      setFormData({
        Email: props.user.email || "",
        FirstName: props.user.firstName || "",
        LastName: props.user.lastName || "",
        Title: props.user.title || "",
        PhoneNumber: props.user.phoneNumber || "",
      });
    }
  }, [props.user, props.open]);

  const handleInputChange = (field: keyof UserUpdateDTO, value: string | boolean | number[]) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    if (!props.user?.userID) return;

    setIsLoading(true);
    try {
      const response = await updateUser(props.user.userID, formData);
      
      if (response) {
        const newUser: User = {
          ...props.user,
          email: formData.Email,
          firstName: formData.FirstName,
          lastName: formData.LastName,
          title: formData.Title,
          phoneNumber: formData.PhoneNumber,
        };

        props.onUserUpdated(newUser);
      }
      
      props.onClose();
    } catch (error) {
      console.error('Error updating user:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return(
    <Dialog
      open={props.open}
      onOpenChange={(_event, data) => !data.open && props.onClose()}
      modalType="alert"
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle            
          action={
            <Button
              appearance="subtle"
              shape="circular"
              aria-label="close"
              icon={<DismissRegular />}
              onClick={props.onClose}
            />
          }>Inställningar</DialogTitle>
          <DialogContent>
            <Field label="E-post:">
              <Input 
                value={formData.Email}
                onChange={(e) => handleInputChange('Email', e.target.value)}
                disabled={!featurePermissions?.some(p => p.action == 'Change user email') ? true : false}
              />
            </Field>
            {/* <Accordion collapsible>
              <AccordionItem value="item-1">
                <AccordionHeader>Redigera lösenord</AccordionHeader>
                <AccordionPanel>
                  <Field label="Lösenord:">
                    <Input type="password" />
                  </Field>
                  <Field label="Upprepa lösenord:">
                    <Input type="password" />
                  </Field>
                </AccordionPanel>
              </AccordionItem>
            </Accordion> */}
            <Field label="Förnamn: ">
              <Input
                disabled={!featurePermissions?.some(p => p.action == 'Change user name') ? true : false}
                value={formData.FirstName}
                onChange={(e) => handleInputChange('FirstName', e.target.value)}
              />
            </Field>
            <Field label="Efternamn: ">
              <Input 
                disabled={!featurePermissions?.some(p => p.action == 'Change user name') ? true : false}
                value={formData.LastName}
                onChange={(e) => handleInputChange('LastName', e.target.value)}
              />
            </Field>
            <Field label="Titel: ">
              <Input
                disabled={!featurePermissions?.some(p => p.action == 'Change user title') ? true : false}
                value={formData.Title || ""}
                onChange={(e) => handleInputChange('Title', e.target.value)}
              />
            </Field>
            <Field label="Telefon: ">
              <Input
                disabled={!featurePermissions?.some(p => p.action == 'Change user phonenumber') ? true : false}
                value={formData.PhoneNumber || ""}
                onChange={(e) => handleInputChange('PhoneNumber', e.target.value)}
              />
            </Field>
          </DialogContent>
          <DialogActions>
            <Button onClick={props.onClose} disabled={isLoading}>Avbryt</Button>
            <Button 
              appearance="primary" 
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? "Sparar..." : "Spara"}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  )
}

export default EditUserDialog;